import { useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { ApiManager } from "../../managers/api-manager";
import { apiIspCompanyUsersAction } from "../../slices/api-isp/api-isp-company-users-slice";
import { dialogAction } from "../../slices/dialog-slice";
import { CompanyUserEditor } from "../pages/company/company-user-editor";
import { Button } from "../ui/button/button";
import { CheckAllValid } from "../../managers/validation/validation";
import { ValidationFactory } from "../../managers/validation/validation-factory";
import { AppAuthModel } from "../../models/authority/app-auth-model";

type Props = {
  companyCode: string;
  memberId: string;
  apiManager: ApiManager;
  callback: () => void;
};

export type CompanyUserData = {
  organization_code: string;
  family_name: string;
  name: string;
  family_name_kana: string;
  name_kana: string;
  display_name: string;
  industry_id: number;
  occupation_id: number;
  role: number;
  is_information: boolean;
  is_log_admin: boolean;
  is_cadect1: boolean;
  is_cadect2: boolean;
  is_cadect3: boolean;
  is_cadect4: boolean;
  is_owner: boolean;
  is_retirement: boolean;
  authorities: string;
}
// バリデーション用意
const validations = {
  require: ValidationFactory('requireEdit'),
  length30: ValidationFactory('length30'),
  length80: ValidationFactory('length80'),
  length256: ValidationFactory('length256'),
  kana: ValidationFactory('kana'),
};

export const CompanyUserEditDialog = (props: Props) => {
  const {
    companyCode,
    memberId,
    apiManager,
    callback,
  } = props;
  const dispatch = useAppDispatch();
  const [isDisabled, setIsDisabled] = useState(CheckAllValid(validations));
  // 有効 (未退職者)
  const [valid, setValid] = useState(true);
  const [authModel, setAuthModel] = useState<AppAuthModel>(new AppAuthModel());
  const [companyUser, setCompanyUser] = useState<CompanyUserData>();
  /** ユーザー更新処理 */
  const updateCompanyUser = () => {
    if (!companyUser) return;
    if (apiManager.type === 'isp') {
      // ISP管理
      const uniqueCadect = authModel.getUniqueCadectData();
      const cadectData = {
        is_cadect1: !!uniqueCadect?.checked,
        is_cadect2: !!uniqueCadect?.['model-eco'],
        is_cadect3: !!uniqueCadect?.['model-air-conditioning'],
        is_cadect4: !!uniqueCadect?.['model-disaster-prevention'],
        is_cadect5: !!uniqueCadect?.['zebzeh-simple-simulation'],
      }
      dispatch(apiIspCompanyUsersAction.update({
      companyCode: companyCode!,
        userId: memberId,
        param: {
          organization_code: companyUser.organization_code,
          family_name: companyUser.family_name,
          name: companyUser.name,
          family_name_kana: companyUser.family_name_kana,
          name_kana: companyUser.name_kana,
          display_name: companyUser.display_name,
          industry_id: companyUser.industry_id,
          occupation_id: companyUser.occupation_id,
          role: companyUser.role,
          is_information: companyUser.is_information,
          is_log_admin: companyUser.is_log_admin,
          ...cadectData,
          is_owner: companyUser.is_owner,
          is_retirement: !valid,
          authorities: authModel.createJson(),
        },
        callback: {
          success: () => {
            dispatch(dialogAction.pushMessage({
              title: '完了',
              message: ['更新しました'],
              buttons: [{
                label: 'OK',
                callback: () => {
                  dispatch(dialogAction.popAll());
                  callback();
                },
              }],
            }));
          },
          failed: () => setIsDisabled(false),
        },
      }));
    }
  };
  /** 更新押下 */
  const handleClickUpdate = () => {
    setIsDisabled(true);
    if (!valid) {
      // 退職アラート
      dispatch(dialogAction.pushMessage({
        title: '確認',
        message: ['退職したユーザーは全ての権限を失います', 'このユーザーを退職させてもよろしいですか'],
        buttons: [{
          label: 'キャンセル',
          callback: () => {
            dispatch(dialogAction.pop());
            setIsDisabled(false);
          },
        },
          {
            label: 'OK',
            callback: () => {
              dispatch(dialogAction.pop());
              updateCompanyUser();
            },
          }],
      }));
      return;
    }
    updateCompanyUser();
  };
  return(
    <>
      <CompanyUserEditor
        companyCode={companyCode}
        memberId={memberId}
        apiManger={apiManager}
        isDialog={true}
        isDisabled={isDisabled}
        setIsDisabled={setIsDisabled}
        valid={valid}
        setValid={setValid}
        authModel={authModel}
        setAuthModel={setAuthModel}
        callback={(companyUser) => setCompanyUser(companyUser)}
      />
      <div className="company_user_dialog__actions">
        <Button
          size="large"
          color="tertiary"
          label="キャンセル"
          onClick={() => dispatch(dialogAction.pop())}
        />
        <Button
          size="large"
          label="更新"
          onClick={handleClickUpdate}
          disabled={isDisabled}
        />
      </div>
    </>
  );
};